import React, { useState, useRef, useEffect, useCallback } from 'react';
import consultingLogo from '../assets/cosultion_club_logo.jpeg';
import personPlaceholder from '../assets/person-placeholder.jpg';
import TaylorVandertoolen from '../assets/TaylorVandertoolen.png';
import MacWolfenbarger from '../assets/MacWolfenbarger.png';
import BenCaine from '../assets/Ben_Caine.png';
import ElizabethMiller from '../assets/Elizabeth_Miller.png';
import SophieMckay from '../assets/Sophie_Mckay.png';
import EzekielJaramillo from '../assets/Ezekiel_Jaramillo.png';
import BenLudlow from '../assets/Ben_Ludlow.png';
import MakaylaFischer from '../assets/Makayla_Fischer.png';
import AbrahamBunting from '../assets/Abraham_Bunting.png';
import MacintyreWilson from '../assets/Macintyre_Wilson.png';
import JosephBoyden from '../assets/Joseph_Boyden.png';
import DarenThai from '../assets/Daren_Thai.png';
import JackJowers from '../assets/Jack_Jowers.png';
import MathewSpurrier from '../assets/Mathew_Spurrier.png';
import JulinaTusieseina from '../assets/Julina_Tusieseina.png';
import KaitlynCurtis from '../assets/Kaitlyn_Curtis.png';
import RobertFalconer from '../assets/Robert_Falconer.jpg';
import ShannonMaughan from '../assets/Shannon_Maughan.png';
import EthanHoj from '../assets/Ethan_Hoj.png';
import EnriqueArias from '../assets/Enrique_Arias.png';
import VedMunot from '../assets/Ved_Munot.png';
import WillBerard from '../assets/Will_Berard.png';
import mcKinseyLogo from '../assets/McKinsey_&_Company-Logo.wine.png';
import bainLogo from '../assets/bain-company-logo-png_seeklogo-324167.png';
import bcgLogo from '../assets/BCG_MONOGRAM.png';
import ciceroLogo from '../assets/CiceroLogo.png';
import oliverWymanLogo from '../assets/Oliver_Wyman.png';
import LekConsulting from '../assets/Lek_Consulting.png';
import Accenture from '../assets/Accenture.png';
import Huron from '../assets/Huron.png';
import Gregor from '../assets/Gregor.jpeg';
import Torlif from '../assets/Torlif.jpeg';
import Kevin from '../assets/KevinRichardson.jpeg';


// 1. ADD photos to src/assets folder
// 2. Import photos into ConsultingClubPage.js
// 3. Search for: ADDSSS to find where to add the new photo

const GOOGLE_API_KEY = 'AIzaSyCBM0d1qUzZU8fsi_Pd5RjOQUuNCOAJpyw';
const CALENDAR_ID = '536aaca6a9af04bea3683e6ddf3818aa2e40d247fe2caa569c5fe44bf4ac9767@group.calendar.google.com';

// Smooth Marquee Slider Component
const MarqueeSlider = ({ items, cardWidth = 280, speed = 2 }) => {
  const containerRef = useRef(null);
  const sliderRef = useRef(null);
  const animationRef = useRef(null);
  const offsetRef = useRef(0);
  const isPausedRef = useRef(false);
  const [initialized, setInitialized] = useState(false);
  
  // Set up the animation
  useEffect(() => {
    // Clone items for seamless looping
    if (containerRef.current && sliderRef.current && !initialized) {
      // Clone the content for seamless looping
      const sliderContent = sliderRef.current.innerHTML;
      sliderRef.current.innerHTML = sliderContent + sliderContent;
      setInitialized(true);
    }
  }, [initialized]);
  
  // Animation loop using requestAnimationFrame
  useEffect(() => {
    if (!initialized) return;
    
    const animate = () => {
      if (!isPausedRef.current && sliderRef.current) {
        // Move the slider
        offsetRef.current = (offsetRef.current + speed) % (items.length * cardWidth);
        sliderRef.current.style.transform = `translateX(-${offsetRef.current}px)`;
      }
      animationRef.current = requestAnimationFrame(animate);
    };
    
    animationRef.current = requestAnimationFrame(animate);
    
    return () => {
      if (animationRef.current) {
        cancelAnimationFrame(animationRef.current);
      }
    };
  }, [initialized, items.length, cardWidth, speed]);
  
  // Handle mouse events for pause/resume
  const handleMouseEnter = () => {
    isPausedRef.current = true;
  };
  
  const handleMouseLeave = () => {
    isPausedRef.current = false;
  };
  
  // Render a single card
  const renderCard = (story, index) => (
    <div 
      key={index} 
      className="marquee-slide"
    >
      <div className="bg-white shadow-xl rounded-xl overflow-hidden transition duration-300 transform hover:scale-105 h-full flex flex-col">
        <div className="p-1 bg-gradient-to-r from-[#BE0000] to-red-800 h-full">
          <div className="bg-white p-6 rounded-lg h-full flex flex-col">
            <div className="flex flex-col items-center mb-6">
              <img 
                src={story.image}
                alt={story.name}
                className="w-28 h-28 object-cover rounded-lg mb-4 border-2 border-[#BE0000]"
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src = personPlaceholder;
                }}
              />
              <h3 className="font-bold text-lg text-center">{story.name}</h3>
            </div>
            <div className="border-t border-gray-100 pt-4 mt-auto">
              <div className="logo-container">
                <img 
                  src={story.companyLogo}
                  alt="Company logo"
                  className={`company-logo ${story.destination.includes('Bain') ? 'bain-logo' : 
                              story.destination.includes('Mckinsey') ? 'mckinsey-logo' : 
                              story.destination.includes('Oliver') ? 'oliver-logo' : 
                              story.destination.includes('Cicero') ? 'cicero-logo' : 
                              story.destination.includes('Boston') ? 'bcg-logo' : ''}`}
                  onError={(e) => {
                    e.target.onerror = null;
                    e.target.src = 'https://via.placeholder.com/150?text=Company';
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
  
  return (
    <div 
      className="marquee-container" 
      ref={containerRef}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      <div className="marquee-track" ref={sliderRef}>
        {items.map((story, index) => renderCard(story, index))}
      </div>
    </div>
  );
};
//successStories Section: ADDSSS
const ConsultingClubPage = () => {
  const successStories = [
    { 
      name: 'Taylor Vandertoolen', 
      destination: 'Bain & Company',
      image: TaylorVandertoolen,
      companyLogo: bainLogo
    },
    { 
      name: 'Joseph Boyden', 
      destination: 'Cicero',
      image: JosephBoyden,
      companyLogo: ciceroLogo
    }, 
    { 
      name: 'Mac Wolfenbarger', 
      destination: 'Boston Consulting Group',
      image: MacWolfenbarger,
      companyLogo: bcgLogo
    },
    { 
      name: 'Ben Caine', 
      destination: 'Bain & Company',
      image: BenCaine,
      companyLogo: bainLogo
    },
    { 
      name: 'Elizabeth Miller', 
      destination: 'Bain & Company',
      image: ElizabethMiller,
      companyLogo: bainLogo
    },
    { 
      name: 'Sophie Mckay', 
      destination: 'Boston Consulting Group',
      image: SophieMckay,
      companyLogo: bcgLogo
    },
    { 
      name: 'Ezekiel Jaramillo', 
      destination: 'Boston Consulting Group',
      image: EzekielJaramillo,
      companyLogo: bcgLogo
    }, 
    { 
      name: 'Ben Ludlow', 
      destination: 'Bain & Company',
      image: BenLudlow,
      companyLogo: bainLogo
    },
    { 
      name: 'Makayla Fischer', 
      destination: 'Boston Consulting Group',
      image: MakaylaFischer,
      companyLogo: bcgLogo
    }, 
    { 
      name: 'Abraham Bunting', 
      destination: 'Bain & Company',
      image: AbrahamBunting,
      companyLogo: bainLogo
    }, 
    { 
      name: 'Macintyre Wilson', 
      destination: 'Bain & Company',
      image: MacintyreWilson,
      companyLogo: bainLogo
    }, 
    { 
      name: 'Jack Jowers', 
      destination: 'Mckinsey and Co',
      image: JackJowers,
      companyLogo: mcKinseyLogo
    }, 
    { 
      name: 'Daren Thai', 
      destination: 'Oliver Wyman',
      image: DarenThai,
      companyLogo: oliverWymanLogo
    },
    { 
      name: 'Mathew Spurrier', 
      destination: 'Bain & Company',
      image: MathewSpurrier,
      companyLogo: bainLogo
    },
    { 
      name: 'Julina Tusieseina', 
      destination: 'Cicero',
      image: JulinaTusieseina,
      companyLogo: ciceroLogo
    },
    { 
      name: 'Kaitlyn Curtis', 
      destination: 'Boston Consulting Group',
      image: KaitlynCurtis,
      companyLogo: bcgLogo
    },
    { 
      name: 'Robert Falconer', 
      destination: 'Bain & Company',
      image: RobertFalconer,
      companyLogo: bainLogo
    },
    { 
      name: 'Shannon Maughan', 
      destination: 'Mckinsey and Co',
      image: ShannonMaughan,
      companyLogo: mcKinseyLogo
    },
    { 
      name: 'Ethan Hoj', 
      destination: 'Lek Consulting',
      image: EthanHoj,
      companyLogo: LekConsulting
    },
    { 
      name: 'Enrique Arias', 
      destination: 'Accenture',
      image: EnriqueArias,
      companyLogo: Accenture
    },
    { 
      name: 'Ved Munot', 
      destination: 'Huron',
      image: VedMunot,
      companyLogo: Huron
    },
    { 
      name: 'Will Berard', 
      destination: 'Cicero',
      image: WillBerard,
      companyLogo: ciceroLogo
    },
     { 
      name: 'Gregor Hawranek', 
      destination: 'Bain',
      image: Gregor,
      companyLogo: bainLogo
    }, 
    { 
      name: 'Torlif Wegener', 
      destination: 'Bain',
      image: Torlif,
      companyLogo: bainLogo
    }, 
    { 
      name: 'Kevin Richardson', 
      destination: 'BCG',
      image: Kevin,
      companyLogo: bcgLogo
    }, 
  ];

  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [showCalendarInfo, setShowCalendarInfo] = useState(false);
  const [upcomingEvents, setUpcomingEvents] = useState([]);
  const [featuredEvent, setFeaturedEvent] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  // Create a reusable fetchEvents function with useCallback
  const fetchEvents = useCallback(async () => {
    try {
      setIsLoading(true);
      setError(null);
      
      // TODO: When you have the API key, replace this with the actual API call
      // This code will work once you have set up your Google Cloud project and API key
      if (GOOGLE_API_KEY === 'YOUR_API_KEY') {
        // Fallback to demo data if API key is not set
        console.log('Using demo data. Please set up your Google Calendar API key.');
        
        // Simulating API response
        setTimeout(() => {
          const today = new Date();
          // Demo event
          const demoEvents = [
            {
              id: '1',
              summary: 'Consulting Case Workshop',
              description: 'Learn how to tackle case interviews with industry experts. This workshop will cover frameworks, practice problems, and tips for success.',
              location: 'Business Building, Room 305',
              start: {
                dateTime: '2023-11-15T18:00:00',
              },
              end: {
                dateTime: '2023-11-15T20:00:00',
              }
            }
          ];
          
          setUpcomingEvents(demoEvents);
          
          // Select the closest upcoming event
          if (demoEvents.length > 0) {
            const closestEvent = demoEvents.reduce((closest, event) => {
              const eventDate = new Date(event.start.dateTime);
              const closestDate = closest ? new Date(closest.start.dateTime) : null;
              
              if (!closest) return event;
              if (eventDate >= today && (!closestDate || eventDate < closestDate)) {
                return event;
              }
              return closest;
            }, null);
            
            if (closestEvent) {
              setFeaturedEvent({
                title: closestEvent.summary,
                description: closestEvent.description,
                location: closestEvent.location,
                startTime: closestEvent.start.dateTime,
                endTime: closestEvent.end.dateTime,
                date: new Date(closestEvent.start.dateTime)
              });
            }
          }
          
          setIsLoading(false);
        }, 1000);
        
        return;
      }
      
      // Format dates for API query
      const today = new Date();
      const timeMin = today.toISOString();
      
      // Real API call
      const apiUrl = `https://www.googleapis.com/calendar/v3/calendars/${encodeURIComponent(CALENDAR_ID)}/events?key=${GOOGLE_API_KEY}&timeMin=${timeMin}&maxResults=10&singleEvents=true&orderBy=startTime`;
      
      console.log('Fetching events from: ', apiUrl);
      
      const response = await fetch(apiUrl);
      
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      
      const data = await response.json();
      
      console.log('API response:', data);
      
      if (data.error) {
        console.error('Google Calendar API error:', data.error);
        throw new Error(`API error: ${data.error.message || 'Unknown error'}`);
      }
      
      if (data.items && data.items.length > 0) {
        console.log(`Found ${data.items.length} upcoming events`);
        setUpcomingEvents(data.items);
        
        // Get the closest upcoming event (first item since we're sorting by startTime)
        const closestEvent = data.items[0];
        console.log('Closest upcoming event:', closestEvent);
        
        setFeaturedEvent({
          title: closestEvent.summary,
          description: closestEvent.description || 'No description available',
          location: closestEvent.location || 'Location TBD',
          startTime: closestEvent.start.dateTime || closestEvent.start.date,
          endTime: closestEvent.end.dateTime || closestEvent.end.date,
          date: new Date(closestEvent.start.dateTime || closestEvent.start.date)
        });
      } else {
        console.log('No upcoming events found');
        setUpcomingEvents([]);
        setFeaturedEvent(null);
      }
    } catch (error) {
      console.error('Error fetching events from Google Calendar API:', error);
      
      // Show error in UI
      setError(error.message || 'Error loading events. Please try again later.');
      setUpcomingEvents([]);
      setFeaturedEvent(null);
    }
    
    setIsLoading(false);
  }, []);  // Empty dependency array since it doesn't use any props or state
  
  // Call fetchEvents on component mount
  useEffect(() => {
    fetchEvents();
  }, [fetchEvents]);  // Add fetchEvents as a dependency

  const scrollToSection = (id, closeMenu = false) => {
    const element = document.getElementById(id);
    if (!element) return;
    
    const offset = 96;
    const bodyRect = document.body.getBoundingClientRect().top;
    const elementRect = element.getBoundingClientRect().top;
    const elementPosition = elementRect - bodyRect;
    const offsetPosition = elementPosition - offset;

    window.scrollTo({
      top: offsetPosition,
      behavior: 'smooth'
    });
    
    if (closeMenu) setIsMenuOpen(false);
  };

  const addToCalendar = () => {
    const event = featuredEvent || {
      title: 'Consulting Case Workshop',
      description: 'Learn how to tackle case interviews with industry experts',
      location: 'Business Building, Room 305',
      startTime: '2023-11-15T18:00:00',
      endTime: '2023-11-15T20:00:00',
    };
    
    // Format dates for Google Calendar URL
    let startTimeFormatted, endTimeFormatted;
    
    if (event.startTime.includes('T')) {
      // This is a timed event
      startTimeFormatted = event.startTime.replace(/[-:]/g, '');
      endTimeFormatted = event.endTime.replace(/[-:]/g, '');
    } else {
      // This is an all-day event - need to format differently
      // For all-day events, Google Calendar expects dates in YYYYMMDD format
      startTimeFormatted = event.startTime.replace(/-/g, '');
      // If the end date is the same as the start date, add 1 day for Google Calendar
      // Google Calendar expects the end date to be exclusive
      if (event.endTime === event.startTime) {
        const endDate = new Date(event.startTime);
        endDate.setDate(endDate.getDate() + 1);
        endTimeFormatted = endDate.toISOString().split('T')[0].replace(/-/g, '');
      } else {
        endTimeFormatted = event.endTime.replace(/-/g, '');
      }
    }
    
    const googleCalendarUrl = `https://www.google.com/calendar/render?action=TEMPLATE&text=${encodeURIComponent(event.title)}&details=${encodeURIComponent(event.description)}&location=${encodeURIComponent(event.location || '')}&dates=${startTimeFormatted}/${endTimeFormatted}`;
    window.open(googleCalendarUrl, '_blank');
  };

  return (
    <div className="font-sans text-black min-h-screen">
      {/* Navigation Bar */}
      <nav className="bg-white shadow-md fixed w-full z-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between h-16">
            <div className="flex">
              <div className="flex-shrink-0 flex items-center">
                <img
                  className="h-10 w-10 object-cover rounded-md"
                  src={consultingLogo}
                  alt="UoU Consulting Club"
                  onError={(e) => {
                    e.target.onerror = null;
                    e.target.src = 'https://via.placeholder.com/40?text=UoU';
                  }}
                />
                <span className="ml-2 font-bold text-[#BE0000] hidden md:block">UoU Consulting Club</span>
              </div>
              <div className="hidden md:ml-6 md:flex md:space-x-8">
                <a
                  href="#about"
                  className="inline-flex items-center px-1 pt-1 border-b-2 border-transparent text-sm font-medium text-gray-900 hover:border-[#BE0000] hover:text-[#BE0000]"
                  onClick={(e) => {
                    e.preventDefault();
                    scrollToSection('about');
                  }}
                >
                  About
                </a>
                <a
                  href="#success-stories"
                  className="inline-flex items-center px-1 pt-1 border-b-2 border-transparent text-sm font-medium text-gray-900 hover:border-[#BE0000] hover:text-[#BE0000]"
                  onClick={(e) => {
                    e.preventDefault();
                    scrollToSection('success-stories');
                  }}
                >
                  Success Stories
                </a>
                <a
                  href="#events"
                  className="inline-flex items-center px-1 pt-1 border-b-2 border-transparent text-sm font-medium text-gray-900 hover:border-[#BE0000] hover:text-[#BE0000]"
                  onClick={(e) => {
                    e.preventDefault();
                    scrollToSection('events');
                  }}
                >
                  Events
                </a>
                <a
                  href="#contact"
                  className="inline-flex items-center px-1 pt-1 border-b-2 border-transparent text-sm font-medium text-gray-900 hover:border-[#BE0000] hover:text-[#BE0000]"
                  onClick={(e) => {
                    e.preventDefault();
                    scrollToSection('contact');
                  }}
                >
                  Contact
                </a>
              </div>
            </div>
            <div className="flex items-center md:hidden">
              <button
                onClick={() => setIsMenuOpen(!isMenuOpen)}
                className="inline-flex items-center justify-center p-2 rounded-md text-gray-700 hover:text-[#BE0000] hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-[#BE0000]"
                aria-expanded="false"
              >
                <span className="sr-only">Open main menu</span>
                {!isMenuOpen ? (
                  <svg
                    className="block h-6 w-6"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    aria-hidden="true"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M4 6h16M4 12h16M4 18h16"
                    />
                  </svg>
                ) : (
                  <svg
                    className="block h-6 w-6"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    aria-hidden="true"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M6 18L18 6M6 6l12 12"
                    />
                  </svg>
                )}
              </button>
            </div>
            <div className="hidden md:flex items-center">
              <a 
                href="https://mccuofu.slack.com/join/shared_invite/zt-2xa3q2ldv-xsyPrhxX5YOGNYzSyEBNVg#/shared-invite/email" 
                target="_blank" 
                rel="noopener noreferrer"
                className="ml-3 bg-[#BE0000] hover:bg-red-800 text-white font-medium py-2 px-4 rounded-lg transition duration-300 shadow-sm hover:shadow-md focus:outline-none focus:ring-2 focus:ring-[#BE0000] focus:ring-offset-2"
              >
                Join Our Slack
              </a>
              <a 
                href="https://utah.instructure.com/enroll/GB7L99" 
                target="_blank" 
                rel="noopener noreferrer"
                className="ml-3 bg-gray-800 hover:bg-gray-700 text-white font-medium py-2 px-4 rounded-lg transition duration-300 shadow-sm hover:shadow-md focus:outline-none focus:ring-2 focus:ring-gray-800 focus:ring-offset-2"
              >
                Add to Canvas
              </a>
            </div>
          </div>
        </div>

        {/* Mobile menu */}
        {isMenuOpen && (
          <div className="md:hidden animate-fadeIn">
            <div className="pt-2 pb-3 space-y-1">
              <a
                href="#about"
                className="block pl-3 pr-4 py-2 border-l-4 border-transparent text-base font-medium text-gray-700 hover:bg-gray-50 hover:border-[#BE0000] hover:text-[#BE0000]"
                onClick={(e) => {
                  e.preventDefault();
                  scrollToSection('about', true);
                }}
              >
                About
              </a>
              <a
                href="#success-stories"
                className="block pl-3 pr-4 py-2 border-l-4 border-transparent text-base font-medium text-gray-700 hover:bg-gray-50 hover:border-[#BE0000] hover:text-[#BE0000]"
                onClick={(e) => {
                  e.preventDefault();
                  scrollToSection('success-stories', true);
                }}
              >
                Success Stories
              </a>
              <a
                href="#events"
                className="block pl-3 pr-4 py-2 border-l-4 border-transparent text-base font-medium text-gray-700 hover:bg-gray-50 hover:border-[#BE0000] hover:text-[#BE0000]"
                onClick={(e) => {
                  e.preventDefault();
                  scrollToSection('events', true);
                }}
              >
                Events
              </a>
              <a
                href="#contact"
                className="block pl-3 pr-4 py-2 border-l-4 border-transparent text-base font-medium text-gray-700 hover:bg-gray-50 hover:border-[#BE0000] hover:text-[#BE0000]"
                onClick={(e) => {
                  e.preventDefault();
                  scrollToSection('contact', true);
                }}
              >
                Contact
              </a>
              <div className="mt-3 flex justify-center space-x-3">
                <a 
                  href="https://mccuofu.slack.com/join/shared_invite/zt-2xa3q2ldv-xsyPrhxX5YOGNYzSyEBNVg#/shared-invite/email" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="w-full mx-1 bg-[#BE0000] hover:bg-red-800 text-white font-medium py-2 px-4 rounded-lg transition duration-150 ease-in-out shadow-sm text-center"
                >
                  Join Our Slack
                </a>
                <a 
                  href="https://utah.instructure.com/enroll/GB7L99" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="w-full mx-1 bg-gray-800 hover:bg-gray-700 text-white font-medium py-2 px-4 rounded-lg transition duration-150 ease-in-out shadow-sm text-center"
                >
                  Add to Canvas
                </a>
              </div>
            </div>
          </div>
        )}
      </nav>

      {/* Hero Section */}
      <section id="about" className="pt-28 bg-gradient-to-b from-[#BE0000] to-red-800 text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20">
          <div className="flex flex-col md:flex-row items-center justify-between">
            <div className="md:w-1/2 md:pr-12 mb-10 md:mb-0">
              <h1 className="text-4xl md:text-5xl font-bold mb-6 leading-tight">
                University of Utah <br /> Management Consulting Club
              </h1>
              <p className="text-lg leading-relaxed mb-8 opacity-90">
                Dedicated to equipping students with the skills and knowledge to succeed in the consulting field. Our mission is to prepare members for case interviews, develop their professional abilities, and provide exposure to the world of consulting.
              </p>
              <div className="flex flex-wrap gap-4">
                <a 
                  href="https://mccuofu.slack.com/join/shared_invite/zt-2xa3q2ldv-xsyPrhxX5YOGNYzSyEBNVg#/shared-invite/email" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="bg-white text-[#BE0000] font-bold py-3 px-6 rounded-lg shadow-lg hover:shadow-xl transition duration-300 transform hover:-translate-y-1 focus:outline-none focus:ring-2 focus:ring-white focus:ring-offset-2 focus:ring-offset-[#BE0000]"
                >
                  Join Our Slack
                </a>
                <a 
                  href="https://utah.instructure.com/enroll/GB7L99" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="bg-transparent border-2 border-white text-white font-bold py-3 px-6 rounded-lg hover:bg-white hover:text-[#BE0000] transition duration-300 focus:outline-none focus:ring-2 focus:ring-white focus:ring-offset-2 focus:ring-offset-[#BE0000]"
                >
                  Add to Canvas
                </a>
              </div>
            </div>
            <div className="md:w-1/2 flex justify-center">
              <div className="relative">
                <div className="absolute inset-0 bg-white rounded-full opacity-10 blur-xl transform -translate-x-4 translate-y-4"></div>
                <img 
                  src={consultingLogo} 
                  alt="UoU Consulting Club" 
                  className="relative w-80 h-80 object-cover rounded-full border-4 border-white shadow-2xl"
                  onError={(e) => {
                    e.target.onerror = null;
                    e.target.src = 'https://via.placeholder.com/300?text=UoU';
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Success Stories Section */}
      <section id="success-stories" className="py-20 bg-white overflow-hidden">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold mb-4">Our Success Stories</h2>
            <div className="w-20 h-1 bg-[#BE0000] mx-auto"></div>
            <p className="mt-4 text-lg text-gray-600 max-w-3xl mx-auto">
              Our members have gone on to work at top consulting firms. Here are some of their success stories.
            </p>
          </div>
        
          <div className="rounded-xl shadow-md relative">
            <MarqueeSlider items={successStories} cardWidth={280} speed={1} />
            <div className="absolute left-0 top-0 bottom-0 w-24 bg-gradient-to-r from-white to-transparent pointer-events-none z-10"></div>
            <div className="absolute right-0 top-0 bottom-0 w-24 bg-gradient-to-l from-white to-transparent pointer-events-none z-10"></div>
          </div>
        </div>
      </section>

      {/* Events Section */}
      <section id="events" className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <div className="flex justify-center items-center mb-4">
              <h2 className="text-3xl md:text-4xl font-bold">Upcoming Events</h2>
              <button 
                onClick={fetchEvents}
                className="ml-4 p-2 text-[#BE0000] hover:bg-gray-200 rounded-full transition-colors focus:outline-none focus:ring-2 focus:ring-[#BE0000]"
                title="Refresh events"
                disabled={isLoading}
              >
                <svg xmlns="http://www.w3.org/2000/svg" className={`h-6 w-6 ${isLoading ? 'animate-spin' : ''}`} fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
                </svg>
              </button>
            </div>
            <div className="w-20 h-1 bg-[#BE0000] mx-auto"></div>
            <p className="mt-4 text-lg text-gray-600 max-w-3xl mx-auto">
              Stay up to date with our workshops, networking events, and case competitions.
            </p>
          </div>
          
          <div className="bg-white rounded-2xl shadow-xl overflow-hidden">
            <div className="relative">
              <div className="h-4 bg-gradient-to-r from-[#BE0000] to-red-800"></div>
              <div className="bg-white p-3 md:p-6">
                <div className="relative rounded-lg shadow-inner overflow-hidden">
                  {/* Mobile-optimized calendar iframe */}
                  <iframe 
                    title="Club Calendar" 
                    src={`https://calendar.google.com/calendar/embed?src=${encodeURIComponent(CALENDAR_ID)}&ctz=America%2FDenver&showTitle=0&showNav=1&showPrint=0&showTabs=1&showCalendars=0&wkst=1`}
                    className="w-full h-96 md:h-[500px] lg:h-[600px] border-0"
                    frameBorder="0" 
                    scrolling="yes"
                    onError={(e) => {
                      e.target.style.display = 'none';
                      const parent = e.target.parentNode;
                      const fallback = document.createElement('div');
                      fallback.innerHTML = '<div class="flex items-center justify-center h-full bg-gray-100 text-gray-500 p-4"><p class="text-center">Calendar currently unavailable. Please check back later.</p></div>';
                      parent.appendChild(fallback);
                    }}
                  ></iframe>
                  
                  {/* Mobile calendar notice */}
                  <div className="block md:hidden mt-4 p-3 bg-blue-50 rounded-lg border border-blue-200">
                    <p className="text-sm text-blue-800">
                      <span className="font-semibold">📱 Mobile Tip:</span> For the best calendar experience on mobile, 
                      <a 
                        href={`https://calendar.google.com/calendar/embed?src=${encodeURIComponent(CALENDAR_ID)}&ctz=America%2FDenver`}
                        target="_blank" 
                        rel="noopener noreferrer"
                        className="underline ml-1 font-medium"
                      >
                        view in Google Calendar
                      </a>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          
          {/* Next Event Card */}
          <div className="mt-12 bg-white rounded-xl shadow-lg overflow-hidden">
            {isLoading ? (
              <div className="p-8 flex justify-center items-center">
                <p>Loading events...</p>
              </div>
            ) : error ? (
              <div className="p-8">
                <div className="text-red-600 mb-2 font-semibold">Error loading events</div>
                <p className="text-gray-700">{error}</p>
                <p className="mt-4 text-sm text-gray-500">
                  Please check your Google Calendar API settings or try again later.
                  You may need to confirm that your calendar is public and accessible.
                </p>
              </div>
            ) : featuredEvent ? (
              <div className="md:flex">
                <div className="md:flex-shrink-0 bg-[#BE0000] text-white md:w-48 flex flex-col justify-center items-center p-6">
                  <div className="text-3xl font-bold">{featuredEvent.date.getDate()}</div>
                  <div className="text-xl">{featuredEvent.date.toLocaleString('default', { month: 'short' }).toUpperCase()}</div>
                  <div className="mt-2">
                    {featuredEvent.startTime.includes('T') ? 
                      featuredEvent.date.toLocaleTimeString([], {hour: '2-digit', minute:'2-digit'}) : 
                      'All Day'
                    }
                  </div>
                </div>
                <div className="p-8">
                  <div className="uppercase tracking-wide text-sm text-[#BE0000] font-semibold">Featured Event</div>
                  <h3 className="mt-1 text-2xl font-medium leading-tight">{featuredEvent.title}</h3>
                  <p className="mt-2 text-gray-600">
                    {featuredEvent.description}
                  </p>
                  <div className="mt-4 flex flex-wrap gap-3">
                    {featuredEvent.location && (
                      <div className="flex items-center text-sm text-gray-500">
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-1 text-[#BE0000]" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                        </svg>
                        {featuredEvent.location}
                      </div>
                    )}
                    <div className="flex items-center text-sm text-gray-500">
                      <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-1 text-[#BE0000]" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                      </svg>
                      {featuredEvent.startTime.includes('T') ? 
                        `${new Date(featuredEvent.startTime).toLocaleTimeString([], {hour: '2-digit', minute:'2-digit'})} - ${new Date(featuredEvent.endTime).toLocaleTimeString([], {hour: '2-digit', minute:'2-digit'})}` : 
                        'All Day'
                      }
                    </div>
                  </div>
                  <div className="mt-6 flex flex-wrap gap-3">
                    <button 
                      onClick={addToCalendar}
                      className="bg-[#BE0000] hover:bg-red-800 text-white font-medium py-2 px-4 rounded-lg transition duration-300 flex items-center focus:outline-none focus:ring-2 focus:ring-[#BE0000] focus:ring-offset-2"
                    >
                      <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
                      </svg>
                      Add to Calendar
                    </button>
                    <button 
                      onClick={() => setShowCalendarInfo(!showCalendarInfo)}
                      className="bg-gray-200 hover:bg-gray-300 text-gray-800 font-medium py-2 px-4 rounded-lg transition duration-300 focus:outline-none focus:ring-2 focus:ring-gray-300 focus:ring-offset-2"
                    >
                      {showCalendarInfo ? 'Hide Details' : 'More Info'}
                    </button>
                  </div>
                  
                  {showCalendarInfo && (
                    <div className="mt-4 p-4 bg-gray-50 rounded-lg animate-fadeIn">
                      <h4 className="font-semibold mb-2">Event Details</h4>
                      <p className="text-sm">
                        {featuredEvent.description}
                      </p>
                      <p className="text-sm mt-2">
                        <strong>Date:</strong> {featuredEvent.date.toLocaleDateString('en-US', {weekday: 'long', year: 'numeric', month: 'long', day: 'numeric'})}
                      </p>
                      <p className="text-sm mt-2">
                        <strong>Time:</strong> {featuredEvent.startTime.includes('T') ? 
                          `${new Date(featuredEvent.startTime).toLocaleTimeString([], {hour: '2-digit', minute:'2-digit'})} - ${new Date(featuredEvent.endTime).toLocaleTimeString([], {hour: '2-digit', minute:'2-digit'})}` : 
                          'All Day'
                        }
                      </p>
                    </div>
                  )}
                </div>
              </div>
            ) : (
              <div className="p-8 flex justify-center items-center">
                <p>No upcoming events found</p>
              </div>
            )}
          </div>
        </div>
      </section>

      {/* Contact Section */}
      <section id="contact" className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold mb-4">Get in Touch</h2>
            <div className="w-20 h-1 bg-[#BE0000] mx-auto"></div>
            <p className="mt-4 text-lg text-gray-600 max-w-3xl mx-auto">
              Have questions about the club or want to join? Reach out to us!
            </p>
          </div>
          
          <div className="flex justify-center">
            <div className="bg-gray-50 p-8 rounded-xl shadow-md max-w-2xl w-full">
              <h3 className="text-2xl font-bold mb-6 text-[#BE0000] text-center">Contact Information</h3>
              <div className="space-y-4">
                <div className="flex items-start">
                  <div className="flex-shrink-0 bg-[#BE0000] p-2 rounded-lg text-white mr-4">
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                    </svg>
                  </div>
                  <div>
                    <p className="font-semibold">Email</p>
                    <a href="mailto:universityofutah.mcc@gmail.com" className="text-[#BE0000] hover:underline">universityofutah.mcc@gmail.com</a>
                  </div>
                </div>
                <div className="flex items-start">
                  <div className="flex-shrink-0 bg-[#BE0000] p-2 rounded-lg text-white mr-4">
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                    </svg>
                  </div>
                  <div>
                    <p className="font-semibold">Location</p>
                    <p className="text-gray-700">Spencer Fox Eccles Business Building<br />1655 East Campus Center Drive<br />Salt Lake City, UT 84112</p>
                  </div>
                </div>
                <div className="flex items-start">
                  <div className="flex-shrink-0 bg-[#BE0000] p-2 rounded-lg text-white mr-4">
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z" />
                    </svg>
                  </div>
                  <div>
                    <p className="font-semibold">Social Media</p>
                    <div className="flex space-x-4">
                      <a href="https://www.instagram.com/uofumcc/#" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white">
                        <svg className="h-6 w-6" fill="currentColor" viewBox="0 0 24 24">
                          <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.40z" />
                        </svg>
                      </a>
                      <a href="https://www.linkedin.com/company/uofumcc/" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white">
                        <svg className="h-6 w-6" fill="currentColor" viewBox="0 0 24 24">
                          <path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z" />
                        </svg>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

        {/* Footer */}
        <footer className="bg-gray-900 text-white py-12">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-10">
              <div>
                <div className="flex items-center mb-4">
                  <img 
                    src={consultingLogo} 
                    alt="UoU Consulting Club" 
                    className="h-12 w-auto mr-3"
                  />
                  <h3 className="text-xl font-bold">UoU Consulting Club</h3>
                </div>
                <p className="text-gray-400 mb-4">
                  Empowering students to succeed in the world of consulting through education, networking, and hands-on experience.
                </p>
                <div className="flex space-x-4">
                  <a href="https://www.instagram.com/uofumcc/#" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white">
                    <svg className="h-6 w-6" fill="currentColor" viewBox="0 0 24 24">
                      <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.40z" />
                    </svg>
                  </a>
                  <a href="https://www.linkedin.com/company/uofumcc/" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white">
                    <svg className="h-6 w-6" fill="currentColor" viewBox="0 0 24 24">
                      <path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z" />
                    </svg>
                  </a>
                </div>
              </div>
              
              <div>
                <h3 className="text-lg font-bold mb-4">Quick Links</h3>
                <ul className="space-y-2">
                  <li><a href="#about" className="text-gray-400 hover:text-white">About Us</a></li>
                  <li><a href="#success-stories" className="text-gray-400 hover:text-white">Success Stories</a></li>
                  <li><a href="#events" className="text-gray-400 hover:text-white">Events</a></li>
                  <li><a href="#contact" className="text-gray-400 hover:text-white">Contact</a></li>
                </ul>
              </div>
              
              <div>
                <h3 className="text-lg font-bold mb-4">About Our Club</h3>
                <p className="text-gray-400 mb-4">
                  The Management Consulting Club at the University of Utah prepares students for consulting careers through case practice, networking events, and professional development.
                </p>
                <div className="flex space-x-4">
                  <a 
                    href="https://mccuofu.slack.com/join/shared_invite/zt-2xa3q2ldv-xsyPrhxX5YOGNYzSyEBNVg#/shared-invite/email" 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="bg-[#BE0000] hover:bg-red-800 text-white px-4 py-2 rounded-lg transition duration-300"
                  >
                    Join Our Slack
                  </a>
                </div>
              </div>
            </div>
          
            <div className="border-t border-gray-800 mt-10 pt-6 flex flex-col md:flex-row justify-between items-center">
              <p className="text-gray-400">© {new Date().getFullYear()} University of Utah Management Consulting Club. All rights reserved.</p>
              <div className="mt-4 md:mt-0">
                <ul className="flex space-x-4 text-sm text-gray-400">
                  <li><a href="#" className="hover:text-white">Privacy Policy</a></li>
                  <li><a href="#" className="hover:text-white">Terms of Use</a></li>
                </ul>
              </div>
            </div>
          </div>
        </footer>
      </div>
    );
};

export default ConsultingClubPage; 